<script>
import { useAlert } from 'dashboard/composables';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: 'edit',
    },
    priceId: {
      type: String,
      default: '',
    },
    gptChatEnabled: {
      type: Boolean,
      default: false,
    },
    merchant: {
      type: Object,
      default: null,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    errorDesc: {
      type: String,
      default: '',
    },
    isTest: {
      type: Boolean,
      default: false,
    },
    onOpen: {
      type: Function,
      default: () => {}
    },
  },
  emits: ['open'],
  data() {
    return {
      isChatwootOpen: false, // 用于防止重复关闭
      isTestChat: this.buttonIcon === "chat-multiple",
      isNotFormat: !this?.merchant && this.buttonIcon !== "chat-multiple",
      isFormat: this?.merchant && this.buttonIcon !== "chat-multiple",
      isTestFormat: this.buttonIcon === "chat-multiple",
    };
  },
  computed: {},
  methods: {
    getDocsUrl(fileUrl) {
      if (!fileUrl) {
        return this.$t("BILLING_SETTINGS.MANAGE_SUBSCRIPTION.SCRIPT_EMPTY")
      }
      const decodedUrl = decodeURIComponent(fileUrl);
      const fileName = decodedUrl.substring(decodedUrl.lastIndexOf('/') + 1);
      return fileName
    },
    handleButtonClick() {
      // 如果 title 是 "customer"，加载 Chatwoot
      if (this.isTestChat) {
        if (this.isTest) {
          let result = this.onOpen();
          console.info("result: ", result);
          if (result) {
            return
          }
        }

        if (this.imageUrl) {
          this.$store.dispatch('accounts/toggleIframeVisible');
          return
        }
        const checkButtonInterval = setInterval(() => {
          console.info(this.gptChatEnabled, "======this.gptChatEnabled======", this.imageUrl)
          if (!this.gptChatEnabled) {
            clearInterval(checkButtonInterval); // 清除定时器
            // 报错提示
            useAlert(this.$t('BILLING_SETTINGS.MANAGE_SUBSCRIPTION.TEST_PROMPT_ERROR'));
            return;
          }
          const chatwootButton = document.querySelector('.woot-widget-bubble');
          console.info(chatwootButton, !this.imageUrl, window.$chatwoot)
          if (chatwootButton && !this.imageUrl && window.$chatwoot) {
            clearInterval(checkButtonInterval);
            window.$chatwoot.toggle();
          }
        }, 100); // 每 100ms 检查一次按钮是否存在
        return;
      }
      // 触发 open 事件，传递 priceId
      this.$emit('open', this.priceId);
    },
  }
};
</script>

<template>
  <div class="manage-subscription">
    <div style="flex: 1;">
      <h6>{{ title }}</h6>
      <p v-if="errorDesc" class="manage-subscription--description" style="color: red">
        {{ errorDesc }}
      </p>
      <p v-if="isNotFormat" class="manage-subscription--description">
        {{ description }}
      </p>
    </div>
    <div>
      <woot-image-button :classNames="'custom-button'" v-if="imageUrl" variant="smooth" :icon="imageUrl"
        @click="handleButtonClick">
        {{ buttonLabel }}
      </woot-image-button>
      <woot-button :classNames="'custom-button'" v-else variant="smooth" :icon="buttonIcon" @click="handleButtonClick">
        {{ buttonLabel }}
      </woot-button>
    </div>
  </div>
</template>

<style>
.custom-button {
  min-width: 140px;
}
</style>
